import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';

@Injectable()
export class AgendaPlannerService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }
}